import * as React from "react";
import PropTypes from "prop-types";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import CircularProgress from "@mui/material/CircularProgress";
import Alert from "@mui/material/Alert";

export default function TableLoadingState({
  isLoading,
  errorMessage,
  colSpan,
  emptyMessage = "No data available.",
}) {
  if (isLoading) {
    return (
      <TableRow>
        <TableCell colSpan={colSpan} align="center">
          <CircularProgress size="2rem" />
        </TableCell>
      </TableRow>
    );
  }

  if (errorMessage != null) {
    return (
      <TableRow>
        <TableCell colSpan={colSpan} align="center">
          <Alert severity="error">{errorMessage}</Alert>
        </TableCell>
      </TableRow>
    );
  }

  return (
    <TableRow>
      <TableCell colSpan={colSpan} align="center">
        <Alert severity="info">{emptyMessage}</Alert>
      </TableCell>
    </TableRow>
  );
}

TableLoadingState.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string,
  colSpan: PropTypes.number.isRequired,
  emptyMessage: PropTypes.string,
};
